import React, { useState, useCallback, useContext } from "react";

import useAxios from "../../services/useAxios";

import CustomButton from "../kits/button/CustomButton";
import { CustomInput } from "../kits/Inputs/Inputs";
import AuthenticationContext from "../../Authentication/AuthenticationContext";
import { useNavigate } from "react-router-dom";

interface VerifyCodeProps {
  mobile: string;
  hashCode: string;
  setStep: (state: number) => void;
}

const VerifyCode: React.FC<VerifyCodeProps> = ({
  mobile,
  hashCode,
  setStep,
}) => {
  const nav = useNavigate();

  const { login } = useContext(AuthenticationContext);

  const { execute, loading } = useAxios("api/login");

  const [code, setCode] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState("");

  const codeInputChangeHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >(
    (event) => {
      setCode(event.target.value);
    },
    [setCode]
  );

  const back = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      setStep(1);
    },
    [setStep]
  );

  const submit = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      if (loading) return;
      if (code.length !== 6) {
        setErrorMessage("لطفا کد ورود را به درستی وارد نمایید.");
        return;
      } else if (errorMessage !== "") {
        setErrorMessage("");
      }
      execute({
        mobile,
        hashcode: hashCode,
        code,
      }).then((res) => {
        if (+res.status === 1) {
          setStep(3);
          let userRoll: number[] = [];
          res.userinfo.user_rolls.map((item: { value: any }) => {
            userRoll.push(parseInt(item.value));
          });
          login(
            res.data.usertoken,
            res.userinfo.fullname,
            res.userinfo.mobile,
            userRoll,
            res.userinfo.id
          );
          nav("/");
        } else if (res.status == -2) {
          setErrorMessage("کاربری شما غیرفعال شده است.");
        } else
          setErrorMessage("متاسفانه مشکلی پیش آمده است، لطفا مجددتلاش کنید.");
        console.log("object*****");
      });
    },
    [mobile, execute, loading, hashCode, code]
  );

  return (
    <form>
      <CustomInput
        type="text"
        label="لطفا کد ارسال شده به شماره تلفن همراه خود را وارد نمایید."
        labelClassName="login-input-label mb-3"
        inputContainer="mb-4 mx-2"
        inputValue={code}
        placeholder="XXXXXX"
        textErr={errorMessage}
        // @ts-ignore
        onChangeFunc={codeInputChangeHandler}
      />
      <div className="login-button-box">
        <CustomButton
          className="btn btn-danger px-3 py-2 w-25 justify-content-center"
          color="warning"
          onClick={back}
        >
          قبلی
        </CustomButton>
        <CustomButton
          className="btn btn-primary px-3 py-2 w-25 justify-content-center"
          color="primary"
          btnType="submit"
          onClick={submit}
        >
          ورود
        </CustomButton>
      </div>
    </form>
  );
};

export default VerifyCode;
